// routes:
import { get } from 'lodash';

export const ANY = '*';
export const ROOT = '/';
export const ADMIN_PREVIEW_PAGE = `${ROOT}preview.html`;
export const ERROR_PAGE = `${ROOT}404.html`;
export const STORY_PATH = {
	domain: `/${get(window, 'STORIES_DOMAIN')}`,
	base: `/${get(window, 'STORY_BASE_PATH')}`,
	story: `/${get(window, 'STORY_JSON_PATH')}`,
	metadata: `/${get(window, 'STORY_METADATA_PATH')}`,
};
export const CARD_SHARE_PATH = `${STORY_PATH.base}/c/:cardId/`;
